/* FB | Fiyatlarda sayi ile "TL" arasina bosluk: "3,499.99TL" -> "3,499.99 TL".
   Shopify money_format'i "{{amount}}TL" (bosluksuz) ve GraphQL ile degistirilemedigi icin
   gorsel normalizasyon. SADECE fiyat alanlarinda calisir (urun adi vb. dokunmaz), idempotent. */
(function () {
  var SEL = '[class*="price"],[class*="Price"],.money,.cart-totals__total-value,.cart-totals__original-value,.fb-custom-product-price,.fb-old-price,.fps-card__price';

  function fixEl(el) {
    var walker, node;
    try { walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null); } catch (e) { return; }
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (t && t.indexOf('TL') > 0 && /[0-9]TL/.test(t)) {
        var nt = t.replace(/([0-9])TL/g, '$1 TL');
        if (nt !== t) node.nodeValue = nt;
      }
    }
  }

  function run() {
    var els;
    try { els = document.querySelectorAll(SEL); } catch (e) { return; }
    for (var i = 0; i < els.length; i++) fixEl(els[i]);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }

  function boot() {
    run();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    try { document.addEventListener('fb:cart-drawer-render-fixed', schedule); } catch (e) {}
    try { window.addEventListener('load', run); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();